import { render, staticRenderFns } from "./CardMyTeam.vue?vue&type=template&id=61f4020c&"
import script from "./CardMyTeam.vue?vue&type=script&lang=js&"
export * from "./CardMyTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports